import React, { Component } from 'react';
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark } from "@fortawesome/free-solid-svg-icons";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import _ from "lodash";
import { addContentTagSuccess } from '../../actions/settings';
import { addEventNameToEndpoint } from '../../utils/common';

const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>
    <div className="d-flex align-items-center">
      <FontAwesomeIcon icon={faBookmark} rotation={270} className="mr-1" color={props.data.color} />{props.value}
      {children}
    </div>
  </components.SingleValue>
);

const Option = props => (
  <components.Option {...props}>
    <div className="d-flex align-items-center m-1">
      <FontAwesomeIcon icon={faBookmark} rotation={270} className="mr-1" color={props.data.color} />
      <span className="ml-2" style={{ color: 'black' }}>{props.label}</span>
    </div>
  </components.Option>
);

class ContentTagEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null
    }
  }

  // thanks https://gist.github.com/mjackson/5311256
  hsvToRgb = (h, s, v) => {
    let r, g, b;

    let i = Math.floor(h * 6);
    let f = h * 6 - i;
    let p = v * (1 - s);
    let q = v * (1 - f * s);
    let t = v * (1 - (1 - f) * s);

    switch (i % 6) {
      case 0: r = v; g = t; b = p; break;
      case 1: r = q; g = v; b = p; break;
      case 2: r = p; g = v; b = t; break;
      case 3: r = p; g = q; b = v; break;
      case 4: r = t; g = p; b = v; break;
      case 5: r = v; g = p; b = q; break;
      default: break;
    }

    return [ Math.round(r * 255), Math.round(g * 255), Math.round(b * 255) ];
  };

  rgbToHex = (rgbArray) => '#' + rgbArray.map(x => {
    const hex = x.toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }).join('');

  // based on golden ratio
  // https://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/
  buildNewTagColor = () => {

    const goldenRatioConjugate = 0.618033988749895;
    let h = Math.random();
    h += goldenRatioConjugate;
    h %= 1;
    const tagColor = this.rgbToHex(this.hsvToRgb(h, 0.5, 0.95));
    return tagColor;
  }

  handleChange = (value, e) => {
    const userId = _.get(this.props, "cognitoUser.username", '');

    if (e.action === 'create-option') {
      addEventNameToEndpoint(this.props.Analytics, 'user-tag-add');

      this.props.Analytics.record({ name: 'user-tag-add', attributes: { contentTagName: this.props.value } });

      this.props.addContentTagSuccess({
        key: value.value,
        color: this.buildNewTagColor(),
        sort: 101
      });

      if (this.props.onChange) {
        this.props.onChange({
          key: value.value,
          color: this.buildNewTagColor(),
          sort: 101,
          createdBy: userId
        });
      }
    } else {
      if (this.props.onChange) {
        const { contentTags } = this.props;

        this.props.onChange({
          key: value.value,
          color: contentTags[value.value].color,
          sort: contentTags[value.value].sort,
          createdBy: userId
        });
      }
    }
  }

  render() {
    const { contentTags } = this.props;
    const options = Object.keys(this.props.contentTags)
      .filter(key => !Object.keys(this.props.selectedTags).includes(key))
      .map(key => ({
        value: key,
        label: key,
        color: contentTags[key].color
      }));

    return (
      <div>
        <CreatableSelect
          className={this.props.className}
          options={options}
          onChange={this.handleChange}
          components={{ Option, SingleValue }}
          placeholder="+ Add tag"
          isDisabled={this.props.disabled}
          value={this.state.value}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  contentTags: state.settings.contentTags,
  Analytics: state.auth.Analytics,
  cognitoUser: state.auth.cognitoUser
});

const mapDispatchToProps = dispatch =>
bindActionCreators({
  addContentTagSuccess
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContentTagEditor);
